import { useEffect, useState } from 'react';
/* eslint-disable import/prefer-default-export */

export const useTimeout = (timeout = 500): boolean => {
  const [timerDone, setTimerDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimerDone(true);
    }, timeout);

    return () => clearTimeout(timer);
  }, [timeout]);

  return timerDone;
};
